import script from "./AppSupport.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppSupport.vue?vue&type=script&setup=true&lang=ts"

import "./AppSupport.vue?vue&type=style&index=0&id=ea090af2&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ea090af2"]])

export default __exports__